/**
 * Tour steps for the Dashboard page.
 * Each step uses stable `data-tour` attribute selectors.
 */
const dashboardSteps = [
  {
    target: '[data-tour="dashboard-welcome"]',
    title: 'Welcome to MediTrack! 👋',
    content:
      'This is your health command center — all your reports, trends, and AI insights live here in one glance.',
    placement: 'bottom',
    skipBeacon: true,
    route: '/dashboard',
    tourName: 'dashboard',
  },
  {
    target: '[data-tour="summary-cards"]',
    title: 'Your health at a glance',
    content:
      'These cards show a quick snapshot — total reports uploaded, alerts that need attention, and your overall health status.',
    placement: 'bottom',
    route: '/dashboard',
    tourName: 'dashboard',
  },
  {
    target: '[data-tour="upload-btn"]',
    title: 'Upload your first report',
    content:
      'Start here — upload your medical reports so we can analyze your health over time. Tap "Next" to see the upload page.',
    placement: 'left',
    route: '/dashboard',
    tourName: 'dashboard',
    navigateOnNext: '/upload',
  },
];

export default dashboardSteps;
